import Breadcrumbs from "@/components/common/sections/Breadcrumbs";
import BreadcrumbsImage from "@/assets/images/breadcrumbs/privacy-policy.webp";

export default function AISolutionsPage() {
	return (
		<>
			<Breadcrumbs
				title="Privacy Policy"
				subtitle=""
				breadcrumbText="Privacy Policy"
				backgroundImage={BreadcrumbsImage}
			/>
		</>
	);
}